import HttpTransport from './http';
import WsTransport from './ws';

export default {
  http: HttpTransport,
  ws: WsTransport,
};



// WEBPACK FOOTER //
// ./src/api/transports/index.js